import { Route, Routes } from "react-router-dom";

import FeedbackCreateScreen from "screens/App/CRM/Feedback/FeedbackCreateScreen";
import FeedbackDetailScreen from "screens/App/CRM/Feedback/FeedbackDetailScreen";
import FeedbackEditScreen from "screens/App/CRM/Feedback/FeedbackEditScreen";
import FeedbackListScreen from "screens/App/CRM/Feedback/FeedbackListScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const FeedbackRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<FeedbackCreateScreen />} />
      <Route path=":id/edit" element={<FeedbackEditScreen />} />
      <Route path=":id/detail" element={<FeedbackDetailScreen />} />
      <Route path="list" element={<FeedbackListScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default FeedbackRouter;
